module.exports = __webpack_public_path__ + "static/stopwatch-f58bde349c11abfa6db0dd58fa36d812.png";